<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div>
    <modal-default title="select item to add" ref="thisModal" v-bind:onsave="doSave" buttontext="Add" size="modal-md mx-4 mx-md-auto">
      <div style="" class="modal-content-container">
        <div class="container-fluid p-0" style="background-color:#f7f7f7">
          <!--<div class="row p-2">
            <div v-bind:id="'card' + template.elementType" class="card col-3 p-0 mr-2 mr-md-4" v-for="template in templates" @click="selectTemplate(template)" style="float:left; margin-left:10px; border:5px solid white;" v-bind:class="{'border-blue': selectedTemplate != null && template.elementType == selectedTemplate.elementType}">
              <div class="card-body p-0 text-center">
                <i class="x2" v-bind:class="template.iconclass"></i><br />
                <span>{{template.text}}</span>
              </div>
            </div>
          </div>-->
          <ul class="nav nav-tabs nav-tabs-highlight mb-0 mr-0" id="elementTabs">
            <li class="nav-item" style="border-left-width:0px !important">
              <a v-bind:href="'#standard_div' + getId()" style="" class="nav-link active show" data-toggle="tab">
                {{$t('standard')}}
              </a>
            </li>
            <li class="nav-item">
              <a v-bind:href="'#advace_div' + getId()" class="nav-link" data-toggle="tab">
                {{$t('advanced')}}
              </a>
            </li>

          </ul>
          <div class="container-fluid elementcontainer pt-3" ref="container" style="">
            <div class="row" style="height: 100%">
              <div class="col p-2" style="padding-left:0px !important">
                <div class="tab-content border-top-0 rounded-top-0 mb-0" style="height: 100%">
                  <div v-bind:id="'standard_div' + getId()" class="tab-pane fade show active pl-1" style="height: 100%">
                    <div v-bind:id="'card' + template.elementType" class="card col-3 p-0 mr-2 mr-md-4" v-for="template in standardtemplates" @click="selectTemplate(template)" style="float:left; margin-left:10px; border:5px solid white;" v-bind:class="{'border-blue': selectedTemplate != null && template.elementType == selectedTemplate.elementType}">
                      <div class="card-body p-0 text-center">
                        <i class="x2" v-bind:class="template.iconclass"></i><br />
                        <span>{{template.text}}</span>
                      </div>
                    </div>
                  </div>
                  <div v-bind:id="'advace_div' + getId()" class="tab-pane fade pl-1" style="height: 100%">
                    <div v-bind:id="'card' + template.elementType" class="card col-3 p-0 mr-2 mr-md-4" v-for="template in templates" @click="selectTemplate(template)" style="float:left; margin-left:10px; border:5px solid white;" v-bind:class="{'border-blue': selectedTemplate != null && template.elementType == selectedTemplate.elementType}">
                      <div class="card-body p-0 text-center">
                        <i class="x2" v-bind:class="template.iconclass"></i><br />
                        <span>{{template.text}}</span>
                        <!--<img v-bind:src="template.image" width="100%" />-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </modal-default>
  </div>

</template>

<script>
  var selectedTemplate = null;

  let templates = [];
  let standardtemplates = [];



  import ModalDefault from "../../modals/modal-default.vue";

  import vuescroll from 'vuescroll';

  export default {
    name: "element-selector",
    components: {
      ModalDefault,
      vuescroll
    },
    props: {

    },
    data() {
      return {
        idGlobal: 0,
        selectedTemplate,
        templates,
        standardtemplates: [],
        ops: {
          vuescroll: {
            mode: 'slide',
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            background: '#F6F7F7',
            opacity: 0.5,
            size: '6px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            onlyShowBarOnScroll: false,
            keepShow: true,
            background: '#666767',
          }
        }
      };
    },
    methods: {
      reset(id) {
        //$('#elementTabs a[href="#' + id + this.getId() + '"]').tab('show');
        this.selectedTemplate = null;
      },
      getDefaultSettings() {
        var s = {
          Property: {}
        };
        return s;
      },
      selectTemplate(template) {
        this.selectedTemplate = template;
        this.$forceUpdate();
      },
      getId() {
        return this._uid;
      },

      open() {
        this.reset("standard_div");
        this.$refs.thisModal.open();

      },
      async doSave() {
        var element = this.selectedTemplate;

        var newText = "";
        if (typeof (element.text) != "undefined" && element.text != null)
          newText = element.text;

        var copy = {
          Id: this.idGlobal--,
          TaskId: -1,
          Name: 'Add a name',
          Text: newText,
          ElementType: element.elementType,
          Settings: element.settings,
          OverRidable: element.overRidable,
          Elements: element.childElements,
          UserInputs: [],
          Url: "",
          IsChanged: true,
          ParentId: null
        }

        this.$root.$emit('selected_element', copy);
        this.$emit('selected_element', copy);
        //this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {
        this.standardtemplates = [{
          iconclass: "icon-typography",
          elementType: 1,
          overRidable: false,
          settings: this.getDefaultSettings(),
          tooltip: this.$t('text'),
          text: this.$t('text'),
          childElements: [],
        },
        {
          iconclass: "icon-checkbox-checked",
          elementType: 2,
          overRidable: false,
          settings: this.getDefaultSettings(),
          tooltip: this.$t('task'),
          text: this.$t('task'),
          childElements: [],
        }, {
          iconclass: "icon-attachment",
          elementType: 0,
          overRidable: false,
          settings: this.getDefaultSettings(),
          tooltip: this.$t('image_or_file'),
          text: this.$t('image_or_file'),
          childElements: [],
        }, {
          iconclass: "icon-upload4",
          elementType: 5,
          overRidable: false,
          settings: this.getDefaultSettings(),
          tooltip: this.$t('user_upload'),
          text: this.$t('user_upload'),
          childElements: [],
          },
          {
            iconclass: "icon-pencil5",
            elementType: 6,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('user_text'),
            text: this.$t('user_text'),
            childElements: [],
          },
          {
            iconclass: "icon-pencil6",
            elementType: 7,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('user_long_text'),
            text: this.$t('user_long_text'),
            childElements: [],
          },
          {
            iconclass: "icon-list",
            elementType: 8,
            overRidable: true,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('user_select'),
            text: this.$t('user_select'),
            childElements: [],
          },
          {
            iconclass: "icon-typography",
            elementType: 19,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('title'),
            text: this.$t('title'),
            childElements: [],
          },
          {
            iconclass: "icon-typography",
            elementType: 20,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('hidden'),
            text: this.$t('hidden'),
            childElements: [],
          },
          {
            iconclass: "icon-typography",
            elementType: 21,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('html editor'),
            text: this.$t('html editor'),
            childElements: [],
          },
          {
            iconclass: "icon-typography",
            elementType: 22,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('slider'),
            text: this.$t('slider'),
            childElements: [],
          },
          /*
          {
            iconclass: "icon-bubble-notification",
            elementType: 10,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('worknote'),
            text: this.$t('worknote'),
            childElements: [],
          }*/
          ];

        this.templates = [
          {
            iconclass: "icon-indent-increase2",
            elementType: 4,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('section'),
            text: this.$t('section'),
            childElements: [],
          },
          {
            iconclass: "icon-qrcode",
            elementType: 9,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('qr_checkpoint'),
            text: this.$t('qr_checkpoint'),
            childElements: [],
          },
          {
            iconclass: "icon-camera",
            elementType: 16,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('camera'),
            text: this.$t('camera'),
            childElements: [],
          },
          {
            iconclass: "icon-touch",
            elementType: 11,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('button'),
            text: this.$t('button'),
            childElements: [],
          },
          {
            iconclass: "icon-versions",
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('slideshow'),
            text: this.$t('slideshow'),
            orientation: "horizontal",
            direction: "downleft",
            elements: [
              {
                iconclass: "icon-versions",
                elementType: 12,
                overRidable: false,
                settings: this.getDefaultSettings(),
                tooltip: this.$t('slideshow'),
                childElements: [{
                  Id: -1,
                  TaskId: -1,
                  Name: 'StartPage',
                  Text: "Start page",
                  ElementType: 13,
                  Settings: this.getDefaultSettings(),
                  OverRidable: false,
                  Elements: [],
                  Url: "",
                  IsChanged: true,
                  ParentId: null,
                  UserInputs: []
                },
                {
                  Id: -1,
                  TaskId: -1,
                  Name: 'StartPage',
                  Text: "Next page",
                  ElementType: 13,
                  Settings: this.getDefaultSettings(),
                  OverRidable: false,
                  Elements: [],
                  Url: "",
                  IsChanged: true,
                  ParentId: null,
                  UserInputs: []
                },
                {
                  Id: -1,
                  TaskId: -1,
                  Name: 'End page',
                  Text: "End page",
                  ElementType: 14,
                  Settings: this.getDefaultSettings(),
                  OverRidable: false,
                  Elements: [],
                  Url: "",
                  IsChanged: true,
                  ParentId: null,
                  UserInputs: []
                }],
              },
              {
                iconclass: "icon-pagebreak",
                elementType: 13,
                overRidable: false,
                settings: this.getDefaultSettings(),
                tooltip: this.$t('new_page'),
                childElements: [],
              },
              {
                iconclass: "icon-pagebreak",
                elementType: 15,
                overRidable: false,
                settings: this.getDefaultSettings(),
                tooltip: this.$t('page_ending'),
                childElements: [],
              },
            ],
            childElements: [],
          },
          {

            iconclass: "icon-pagebreak",
            elementType: 13,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('new_page'),
            text: this.$t('new_page'),
            childElements: [],
          },
          {
            iconclass: "icon-pagebreak",
            elementType: 15,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('page_ending'),
            text: this.$t('page_ending'),
            childElements: [],
          },
          {
            iconclass: "icon-camera",
            elementType: 18,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('video'),
            text: this.$t('video'),
            childElements: [],
          },
          /*
          {
            iconclass: "icon-calendar2",
            elementType: 17,
            overRidable: false,
            settings: this.getDefaultSettings(),
            tooltip: this.$t('calendar'),
            text: this.$t('calendar'),
            childElements: [],
          },*/
        ];
      }
    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>

  .modal-content-container {
    height: 250px !important;
    overflow-y: auto;
  }

  .elementcontainer{
      max-height:200px;
      overflow-y:auto;
  }

  @media (max-width: 768px) {
    .modal-content-container {
      height: calc(100vh - 250px) !important;
    }
    .elementcontainer {
      max-height: none;
      overflow-y: initial;
    }
  }

  .card.border-blue {
    border-color: #03a9f4 !important;
  }

  .card:hover {
    box-shadow: 0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-editor-elements/element-selector.vue